import React, { Component } from 'react'
import connexion from '../../connexion'
import { ArrowRightIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom'

class ModuleAnimation extends Component {
	constructor(props) {
		super(props)
		this.state = {
			date: null,
			animation: undefined,
			category_name: null
		}
	}

	componentDidMount() {
		this.loadAnimation()
	}

	loadAnimation = () => {
		this.props.fetchAnimationNext()
		.then(ret => {
			if (ret !== null)
			{
				this.setState({ date: ret.date, animation: ret.animation })
				this.loadCategory(ret.animation)
			}
			else
				this.setState({ date: null, animation: null })
		})
		.catch(err => console.log(err))
	}

	loadCategory = (animation) => {
		if (!animation || !animation.category || !this.props.fetchAnimationCategories)
			return ;
		this.props.fetchAnimationCategories()
		.then(categories => {
			let category_name = null
			for (let i = 0; i < categories.length; i++)
			{
				if (String(categories[i]._id) === String(animation.category))
				{
					for (let j = 0; j < categories[i].translations.length; j++)
					{
						if (categories[i].translations[j].lang === this.props.user.lang)
						{
							category_name = categories[i].translations[j].name
							break
						}
					}
					break
				}
			}
			this.setState({ category_name: category_name })
		})
		.catch(err => console.log(err))
	}

	//"18h05" à partir d'un objet Date
	_formatHour = (dateObj) => {
		let m = dateObj.getMinutes()
		if (m < 10)
			m = '0' + m
		return dateObj.getHours() + "h" + m
	}

	//libellé du jour : Aujourd'hui / Ce soir (dès 18h) / Demain / "Sam. 18 juil."
	_formatDay = (start, now) => {
		const time = this.props.lang_assets.time
		const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate())
		const nowDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
		const diff = Math.round((startDay.getTime() - nowDay.getTime()) / 86400000)
		if (diff === 0)
			return (start.getHours() >= 18) ? this.props.lang_assets.home.tonight : time.today
		if (diff === 1)
			return time.tomorrow
		return time.weekdays_short[start.getDay()] + " " + start.getDate() + " " + time.months_short[start.getMonth()]
	}

	render() {
		const date = this.state.date
		const animation = this.state.animation
		if (date && animation)
		{
			const cover = (animation.cover || animation.cover_ext) ? "url(" + connexion.connect.url + 'webapp/animations/cover?id=' + animation._id + ")" : "url(" + animation.cover + ")"
			const now = new Date()
			const start = new Date(date.start * 1000)
			const end = (date.end) ? new Date(date.end * 1000) : null
			const urlDate = new Date(start.getFullYear(), start.getMonth(), start.getDate())
			const url = this.props.lang_assets.paths.activities + '/' + Math.floor(urlDate.getTime() / 1000)
			const dayTxt = this._formatDay(start, now)
			let hoursTxt = this._formatHour(start)
			if (end)
				hoursTxt += " - " + this._formatHour(end)
			let name = ""
			for (let i = 0; i < animation.translations.length; i++)
			{
				if (animation.translations[i].lang === this.props.user.lang)
				{
					name = animation.translations[i].name
					break
				}
			}
			const theme_color = (this.props.theme) ? '#' + this.props.theme.color1 : '#111827'
			return (
				<div>
					<h2 className="text-xl font-bold ml-5 mt-7">{this.props.title}</h2>
					<Link to={url}>
						<div className="pressable w-11/12 mt-3 mx-auto mb-5 rounded-2xl overflow-hidden bg-white" style={{ border: '1px solid #E8E9EC', boxShadow: '0 4px 14px rgba(0, 0, 0, 0.10)' }}>
							<div className="relative h-36 bg-cover bg-center" style={{ backgroundImage: cover }}>
								<span className="absolute px-3 py-1 rounded-full font-bold text-gray-900 shadow" style={{ top: '10px', left: '10px', fontSize: '13px', backgroundColor: 'rgba(255, 255, 255, 0.94)' }}>{dayTxt}</span>
							</div>
							<div className="px-4 pt-3 pb-3">
								<p className="text-gray-900 font-bold leading-snug" style={{ fontSize: '16.5px' }}>{name}</p>
								{this.state.category_name && <p className="text-gray-500 text-sm mt-0.5">{this.state.category_name}</p>}
								<div className="flex items-end justify-between border-t border-gray-100 mt-3 pt-2.5">
									<div>
										<p className="text-gray-400 font-semibold uppercase" style={{ fontSize: '11px', letterSpacing: '0.05em' }}>{this.props.lang_assets.home.schedule}</p>
										<p className="text-gray-900 font-bold text-sm">{hoursTxt}</p>
									</div>
									<p className="font-bold text-sm flex items-center" style={{ color: theme_color }}>
										{this.props.lang_assets.home.see_program}
										<ArrowRightIcon className="h-4 w-4 ml-1" />
									</p>
								</div>
							</div>
						</div>
					</Link>
				</div>
			)
		}
		else if (animation === undefined)
		{
			return (
				<div className="animate-pulse w-11/12 mt-4 relative mx-auto mb-5 bg-gray-200 rounded-xl h-56 shadow-lg">
					<div className="flex justify-end">
				 		<span className="items-end mt-3 mr-3 px-3 py-0.5 rounded-full text-base font-medium bg-gray-100 text-gray-800">En attente</span>
				 	</div>
					<div className="w-full h-20 absolute bottom-0 rounded-xl text-white text-xl font-medium flex items-end p-2">
						<p className="mx-auto">{this.props.lang_assets.home.loading}</p>
					</div>
				</div>
			)
		}
		else
			return null
	}
}

export default ModuleAnimation
